import React, {useMemo} from 'react';

import {AutosuggestItem} from '@pb/kit-component-autosuggest-v2';
import {AvatarWrapped, Size} from '@pb/kit-component-avatar';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group} from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';

import type {AdminSearchInfo} from 'src/openapi/admin/models/AdminSearchInfo';

type Props = {
    admin: AdminSearchInfo,
};

export const AdminSuggestItem = ({admin}: Props) => {
    const fullName = useMemo(
        () => [admin.userInfo.firstName, admin.userInfo.lastName].join(' '),
        [admin],
    );

    return (
        <AutosuggestItem
            key={admin.userInfo.userId}
            value={admin}
            caption={(
                <Group alignItems="center">
                    <AvatarWrapped
                        src={admin.userInfo.avatar}
                        alt={admin.userInfo.userId.toString()}
                        placeholder={Icons.USER}
                        size={Size.SMALL}
                        name={fullName}
                    />
                    <div style={{width: 130}}>
                        <EllipsisTextHint title={fullName}>
                            {fullName}
                        </EllipsisTextHint>
                    </div>
                    <div style={{width: 200}}>
                        {admin.currentProfile ? (
                            <EllipsisTextHint title={admin.currentProfile.profileName}>
                                {admin.currentProfile.profileName}
                            </EllipsisTextHint>
                        ) : null}
                    </div>
                    <b style={{width: 300}}>
                        <EllipsisTextHint title={admin.userInfo.email} mix="disabled">
                            {admin.userInfo.email}
                        </EllipsisTextHint>
                    </b>
                </Group>
            )}
        />
    );
};
